import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M13 21.385 21.385 16 13 10.615zm3.002 7.282q-2.627 0-4.94-.998a12.8 12.8 0 0 1-4.023-2.707 12.8 12.8 0 0 1-2.708-4.02q-.998-2.312-.998-4.94 0-2.627.998-4.94a12.8 12.8 0 0 1 2.707-4.023 12.8 12.8 0 0 1 4.02-2.708q2.312-.998 4.94-.998t4.94.998a12.8 12.8 0 0 1 4.023 2.707 12.8 12.8 0 0 1 2.708 4.02q.998 2.312.998 4.94t-.998 4.94a12.8 12.8 0 0 1-2.707 4.023 12.8 12.8 0 0 1-4.02 2.708q-2.312.998-4.94.998"
    }, null, -1)
  ]))]))
}
export default { render: render }